<script>
import MediaQuery from './../../../components/MediaQuery.svelte';
import IncludedServices from './IncludedServices.svelte';
import StaticLink from 'tripod-styles/src/components/Buttons/StaticLink.svelte';
import HeaderPlan from './HeaderPlan.svelte';
import allowed_included_services from './allowed_included_services';
import { BuildIncludedServices } from './BuildIncludedServices';
import InfoIcon from 'tripod-styles/src/components/Elements/SpecialIcons/InfoIcon.svelte';
import { Contents } from 'tripod-styles/src/components/ContentsPlatform.store';

export let parsedPlans = [];
export let benefits_items = {};
export let has_products;
export let metadata;
export let interval;
export let SelectPlanInit;
export let select_plan_lang;
export let set_value_benefit;
export let lang;
export let see_more_details;
export let close_details;

let show_details;

let container = null;
let current = 0;
let animation = "animate__fadeInUp";

let membership_type = null;

/**
 * @type {BuildIncludedServices}
 */
 let additionals_instance = new BuildIncludedServices(()=> additionals_instance = additionals_instance);

function change_plan(switch_way){
    
    let position = current;
    let max = parsedPlans.length - 1;

    animation = "animate__fadeOutLeft";

    setTimeout(()=>{
        animation = "animate__fadeInRight";
        if(switch_way === "left"){
            position--;
        }

        if(position < 0){
            position = max;
        }


        if(switch_way === "right"){
            position++;
        }

        if(position > max){
            position = 0;
        }

        current = position;
    }, 500)
}

let many_benefits = false;

$: {
    if(parsedPlans){
        many_benefits = false;
        parsedPlans.map((plan)=>{
            membership_type = plan.membership_type;
            
            if(allowed_included_services(membership_type)){
                additionals_instance.build_additional(plan);
            }

            if(many_benefits === true){return;}
            if(Object.values(plan.benefits).length > 6){
                many_benefits = true;
            }
        })
    }
}

</script>
<container-plans-selector class="columns pt-alt-4 mb-0" bind:this={container}>
    {#if parsedPlans.length > 0}
        {#each parsedPlans as plan, keyPlan}
            <div class="column is-paddingless is-marginless column-wrapper animate__animated animate__faster {animation} {current === keyPlan ? "active" : ""}">
                <HeaderPlan
                    has_products={has_products}
                    metadata={metadata}
                    interval={interval}
                    SelectPlanInit={SelectPlanInit}
                    select_plan_lang={select_plan_lang}
                    lang={lang}
                    plan={plan}
                >
                    <card-plan-options class="column pt-0 column-card-plan card-space-content container-plan-{plan.__id__} is-relative">
                        <section class="{plan.is_recommended} {has_products ? 'has-products pt-0' : ""} is-relative subcontainer has-background-white section-card is-plan padding-40">
                            {#if parsedPlans.length > 0}
                                {#each Object.values(plan.benefits).filter((item)=>{
                                    if(item.type === "boolean"){
                                        if(item.value === false){
                                            return false;
                                        }
                                    }

                                    if(item.type === "number"){
                                        if(item.value === 0 && item.can_be_unlimited){
                                            return false;
                                        }
                                    }


                                    if(item.hidden){
                                        return false;
                                    }

                                    return item;
                                }) as benefit, key}   
                                    <h3 class="benefit-value m-0 has-text-centered is-flex plan-{keyPlan}-switch {(key >= 6) ? `element-hiddable hidden-item` : ""} is-align-items-center">              
                                        <span class="font-size-14 fw400 full-width">
                                            {@html set_value_benefit(benefit, true)}
                                        </span>
                                        {#if typeof benefit.info_ctn === "string" && benefit.info_ctn !== ""}
                                            <span data-tooltip={Contents.get(benefit.info_ctn, Contents.search(benefit.info_ctn, window.lang_selected))} class="has-tooltip has-tooltip-multiline has-tooltip-left">
                                                <InfoIcon />
                                            </span>
                                        {/if}
                                    </h3>           
                                {/each}
                            {/if}
                            <selectors-plan>
                                <button type="button" class="button is-primary left-button is-outlined" on:click={()=>{
                                    change_plan("left")
                                }}>
                                    <i class="icon-tripod-arrow-left"></i>
                                </button>
                                <button type="button" class="button is-primary right-button is-outlined" on:click={()=>{
                                    change_plan("right")
                                }}>
                                    <i class="icon-tripod-arrow-right"></i>
                                </button>
                            </selectors-plan>
                        </section>
                        {#if many_benefits}
                            <footer-element class="is-block is-relative">
                                <section class="{plan.is_recommended} {has_products ? 'has-products pt-0' : ""} is-relative subcontainer has-background-white section-card is-plan padding-40">
                                    <div class="is-flex has-text-centered is-justify-content-center">
                                        <StaticLink class="has-text-primary" on:click={()=>{
                                            let items = [...container.querySelectorAll(`.plan-${keyPlan}-switch.hidden-item`)];
                                            items.map((item)=>{
                                                if(item.classList.contains("element-hiddable")){
                                                    item.classList.remove("element-hiddable");
                                                    show_details = true;
                                                }else{
                                                    item.classList.add("element-hiddable");
                                                    show_details = false;
                                                }
                                            })
                                        }}>
                                            {!show_details ? see_more_details : close_details}
                                        </StaticLink>
                                    </div>
                                </section>
                            </footer-element>
                        {/if}
                    </card-plan-options>
                </HeaderPlan>
                <MediaQuery query="(max-width:900px)">
                    {#if parsedPlans.length > 0 && allowed_included_services(membership_type)}
                        <IncludedServices
                            plan={plan}
                            membership_type={membership_type} 
                            parsedPlans={parsedPlans}
                            additionals_instance={additionals_instance}
                        />
                    {/if}
                </MediaQuery>
            </div>
        {/each}
    {/if}
</container-plans-selector>
<MediaQuery query="(min-width:901px)">
    {#if parsedPlans.length > 0 && allowed_included_services(membership_type)}
        <IncludedServices 
            membership_type={membership_type} 
            parsedPlans={parsedPlans}
            additionals_instance={additionals_instance}
        />
    {/if}
</MediaQuery>
<style>
container-plans-selector{
    background-color: #fff;
}
.card-plan-options{
    padding-top: 0;
    border-radius: 0 0 20px;
}
.column-card-plan .subcontainer{
    border-radius: 0;
    padding: 1.25rem !important;
}
.column-card-plan footer-element section.subcontainer{
    border-radius: 0 0 20px 20px;
}
.benefit-value:global(.element-hiddable){
    display: none !important;
}
selectors-plan button.button{
    padding: 7px 10px;
    background: #fff !important;
    z-index: 5;
}
.left-button{
    position: absolute;
    margin-bottom: -50%;
    top: calc(50% - 30px);
    left: -14px;
}
.right-button{
    position: absolute;
    margin-top: -50%;
    bottom: calc(50% - 30px);
    right: -14px;
}
.column-wrapper:not(.active){
    display: none;
}
</style>